module.exports = __webpack_public_path__ + "img/minus-icon.75f02858.svg";